import "./jquery-1.11.1.min";
import "./jquery.sticky-kit.min";

if ($(window).width() < 1439) {
  $("#sticky-scroll").stick_in_parent({
    offset_top: 0,
  });
}

